import { createSelector } from 'reselect';
import { hasTuitionTypeOrDefaultSelector } from '../ChildrenInfoWorkflowSelector';
import { TUITION_TYPE } from '../../Summaries/SummaryConstants';
import dictionarySelector from '../../Summaries/SummaryDictionarySelector';

const nextIteratorsSelector = createSelector(
  hasTuitionTypeOrDefaultSelector,
  dictionarySelector,
  (hasTuitionType, dictionary) => {
    if (hasTuitionType === true) {
      return [TUITION_TYPE].map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);

export default nextIteratorsSelector;
